import script from "./ABSViolationList.vue?vue&type=script&setup=true&lang=js"
export * from "./ABSViolationList.vue?vue&type=script&setup=true&lang=js"

import "./ABSViolationList.vue?vue&type=style&index=0&id=63f6ddac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f6ddac"]])

export default __exports__